import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'lcm-sidebar-link',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, MatTooltipModule, MatListModule, RouterLink, RouterLinkActive],
  styles: `
    a:not(.active) [matListItemMeta] {
      visibility: hidden;
    }
  `,
  template: `
    <a mat-list-item [routerLink]="[link()]" routerLinkActive="active">
      <mat-icon matListItemIcon>{{ icon() }}</mat-icon>
      <ng-content />
      <span matListItemMeta>
        <mat-icon>remove_red_eye</mat-icon>
      </span>
    </a>
  `,
})
export class SidebarLink {
  link = input.required<string>();
  icon = input.required<string>();
}
